import { RecordWithPlaintext } from '@puzzlehq/sdk';
import { getNestedStringProperty } from '@puzzlehq/types';

export const getIsIOSWebView = () => {
  const ua = window.navigator.userAgent.toLowerCase();
  return (
    ua.includes('applewebkit') &&
    !ua.includes('safari') &&
    !ua.includes('chrome') &&
    !ua.includes('android')
  );
};

export const getIsIOS = () => {
  const ua = window.navigator.userAgent;
  const iOS = !!ua.match(/iPad/i) || !!ua.match(/iPhone/i);
  return iOS && !ua.match(/CriOS/i);
};

export const getRecordPartBalance = (record: RecordWithPlaintext) => {
  try {
    return (
      Number(
        getNestedStringProperty(record.data, ['amount'])?.replace(
          'u64.private',
          ''
        ) ?? 0
      ) / 1_000_000
    );
  } catch (e) {
    console.error(e);
    return 0;
  }
};

export const COIN_CONTRACT = import.meta.env.VITE_COIN_CONTRACT!;
export const COIN_RECORD_NAME = 'PuzzleArcadeCoin';

export const TICKET_CONTRACT = import.meta.env.VITE_TICKET_CONTRACT!;
export const TICKET_RECORD_NAME = 'PuzzleArcadeTicket';
